import { IPAY_FETCH_SUCCESS, DOWNLOAD_IPAY_SUCCESS } from '../constant/actionType';

const initialState = {
  csv: null,
  iPays: [],
  isLoaded: false
};

const iPayReducer = (state = initialState, action) => {
  switch (action.type) {
    case IPAY_FETCH_SUCCESS:
      return {
        ...state,
        iPays: action.data,
        isLoaded: true
      };

    case DOWNLOAD_IPAY_SUCCESS:
      return {
        ...state,
        csv: action.data
      };

    default:
      return state;
  }
};

export default iPayReducer;
